import { render, staticRenderFns } from "./lottery-3D.vue?vue&type=template&id=0d60b66a&scoped=true"
import script from "./lottery-3D.vue?vue&type=script&lang=js"
export * from "./lottery-3D.vue?vue&type=script&lang=js"
import style0 from "./lottery-3D.vue?vue&type=style&index=0&id=0d60b66a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60b66a",
  null
  
)

export default component.exports